import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import axios from "axios"
import { FORGET_PASSWORD } from "./actionTypes"
import { userForgetPasswordSuccess, userForgetPasswordError } from "./actions"
import config from "config/config"

function* forgetUser({ payload: { user } }) {
  try {
    yield call(axios.post, `${config.backendUrl}/auth/forgot-password`, {
      email: user.email,
    })
    yield put(
      userForgetPasswordSuccess(
        "If that email is registered, a reset link has been sent. Check your mailbox."
      )
    )
  } catch (error) {
    const message =
      error?.response?.data?.message || "Something went wrong. Please try again."
    yield put(userForgetPasswordError(message))
  }
}

export function* watchUserPasswordForget() {
  yield takeEvery(FORGET_PASSWORD, forgetUser)
}

function* forgetPasswordSaga() {
  yield all([fork(watchUserPasswordForget)])
}

export default forgetPasswordSaga
